import React, { useState } from "react";
import { Button, Col, Container, Row} from "react-bootstrap";
import Cabecalho from "../../../components/Cabecalho/Cabecalho";
import FormBuscarUsuario from "../../../components/Form/FormBuscarUsuario";
import CadastroUsuario from "./components/FormCadastroUsuario";
import UsuarioList from "./components/UsuarioList";

import { useNavigate } from "react-router-dom";
import { BiArrowBack, BiDownload, BiPlus } from "react-icons/bi";
import EditarUsuario from "./components/FormEditarUsuario";
import RolesPermissoes from "./RolesPermissoes";

import LoadSpinner from "../../../components/LoadSpinner/LoadSpinner";
import ConfirmDialog from "../../../components/dialog/ConfirmDialog";

import api from "../../../services/api";
import { hasPermission } from "../../../Utils/permissions";

import "./styles/style.css"



const DashboardUsuarios = () => {
    const canManageUsers = hasPermission("users.manage");
    const canViewRoles = hasPermission("roles.view");

    const [usuarioList, setUsuarioList] = useState([])

    const [modo, setModo] = useState("BUSCAR") // BUSCAR, CADASTRAR, EDITAR

    const [idBusca, setIdBusca] = useState()
    const [usuarioSelecionado, setUsuarioSelecionado]= useState(null)
    const [loading, setLoading]= useState(false)
    const [showConfirm, setShowConfirm] = useState(false);
    const [userToRemove, setUserToRemove] = useState(null);
    const [rolesVisible, setRolesVisible] = useState(false);

    const navigate = useNavigate()    

    const handleClickBuscarUsuarios = ()=>{
        setModo("lista")
        setLoading(true)
        api.get("/user")
        .then((response)=>{
            setUsuarioList(response.data)
        }).catch(function (error) {
            console.error(error)
        })
        .finally(function () {
            setLoading(false)
        });
    }

    const handleClickBuscarUsuario = ()=>{
        setModo("lista")
        setLoading(true)
        api.get(`/user/${idBusca}`)
        .then((response)=>{
            setUsuarioList(response.data)
        }).catch(function (error) {
            console.error(error)
        })
        .finally(function () {
            setLoading(false)
        });
    }

    
    const handleClickEditarUsuario = (_id) => {
        const usuario = usuarioList.find((u) => u._id === _id);
        if (!usuario) { return}
        setUsuarioSelecionado(usuario);
        setModo("edicao");
        };
    

    const handleClickRemoverUsuario = () => {
        api.delete(`/user/${userToRemove}`)
        .then((response) => {
            setUsuarioList((prev) =>
            prev.filter((user) => user._id !== userToRemove)
        );
            setShowConfirm(false);
            setUserToRemove(null);
        })
        .catch((error) => {
            console.error(error);
            setShowConfirm(false);
        });
    };


    const handleClickRegistrarUsuarios = ()=>{
        setModo("cadastro");
        setUsuarioList([])

    }

    const handleClickConfirmarRemocao = (_id) => {
        setUserToRemove(_id);
        setShowConfirm(true);
    };


    const handleClickVoltar = ()=>{
        navigate("/dashboard")
    }

    return ( 
    <>
        <Cabecalho/>
        <Container className="mt-5">
           <FormBuscarUsuario setIdBusca={setIdBusca} handleClickBuscarUsuarios={handleClickBuscarUsuario} />
            <Row>
                <Col className="d-grid gap-2 d-md-block mt-2 mb-2">
                    {rolesVisible && (
                        <Button size="sm" variant="outline-secondary" onClick={() => setRolesVisible(false)}>
                            Voltar aos usuários <BiArrowBack/>
                        </Button>
                    )}
                    <Button size="sm" variant="warning" onClick={handleClickBuscarUsuarios}>
                        Carregar Usuários <BiDownload/>
                    </Button>
                    {" "}
                    {canManageUsers && <Button size="sm" variant="success" onClick={handleClickRegistrarUsuarios}>
                        Cadastrar Usuário <BiPlus/>
                    </Button>}
                    {" "}
                    <Button size="sm"  variant="outline-primary" onClick={handleClickVoltar}>
                        Voltar <BiArrowBack/>
                    </Button>
                    {canViewRoles && <Button size="sm" variant="outline-dark" onClick={() => setRolesVisible(true)}>
                        Roles e Permissões
                    </Button>}
                </Col>
            </Row>
            <Row>
                <LoadSpinner visible={loading} text="Carregando Usuários"/>
            </Row>

            <ConfirmDialog
                show={showConfirm}
                title="Excluir usuário"
                message="Deseja excluir o usuário realmente?"
                confirmText="Excluir"
                cancelText="Cancelar"
                onConfirm={handleClickRemoverUsuario}
                onCancel={() => setShowConfirm(false)}
            />

            {rolesVisible && <RolesPermissoes />}

            {!rolesVisible && modo === "lista" && (
            <Row>
                <UsuarioList
                    usuarioList={usuarioList}
                    onEditar={canManageUsers ? handleClickEditarUsuario : undefined}
                    onRemover={canManageUsers ? handleClickConfirmarRemocao : undefined}
                />
            </Row>
            )}

            {!rolesVisible && modo === "cadastro" && <CadastroUsuario />}

            {!rolesVisible && modo === "edicao" && usuarioSelecionado && (
                <EditarUsuario
                    usuario={usuarioSelecionado}
                    setExibirFormEdicao={() => setModo("lista")}
                />
            )}
        </Container>

    </> );
}
 
export default DashboardUsuarios;